import { useCallback, useRef } from 'react';
import { useKeyboard } from './useKeyboard';

export const useScrollHandler = (mustHandleKeyboard: boolean) => {
  const { keyboardState, hideKeyboard } = useKeyboard();
  const lastScrollTop = useRef(0);

  return useCallback(
    (event: React.UIEvent<HTMLDivElement>) => {
      const currentScrollTop = event.currentTarget.scrollTop;

      if (
        currentScrollTop > lastScrollTop.current &&
        mustHandleKeyboard &&
        keyboardState.isVisible
      ) {
        hideKeyboard();
      }

      const activeElement = document.activeElement as HTMLElement;
      if (activeElement) {
        activeElement.blur();
      }

      lastScrollTop.current = currentScrollTop;
    },
    [mustHandleKeyboard, keyboardState.isVisible, hideKeyboard]
  );
};
